import { render, staticRenderFns } from "./UserSkills.vue?vue&type=template&id=022f1e8e"
import script from "./UserSkills.vue?vue&type=script&lang=js"
export * from "./UserSkills.vue?vue&type=script&lang=js"
import style0 from "./UserSkills.vue?vue&type=style&index=0&id=022f1e8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports